import {createArray} from "@Common/utils/collections";

export const getLines = (data) => createArray(5).map((i) => data?.["line" + (i+1)]?.toUpperCase() ?? "");
